import { render, staticRenderFns } from "./BtnIcons.vue?vue&type=template&id=34eaedd0&"
import script from "./BtnIcons.vue?vue&type=script&lang=js&"
export * from "./BtnIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports